<template>
	<div>
		<div class="doctorPage doctorSeach">
			<div class="selectSearch">
				<el-form ref="form" :model="adminappealParameter" class="qcFrom" :inline="true">
					<el-form-item label="类型">
						<el-select v-model="adminappealParameter.type" placeholder="请选择类型" size="mini" class="name" @change="search">
							<el-option label="报告" :value="2"></el-option>
							<el-option label="影像" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="adminappealParameter.appealStatus" placeholder="请选择状态" size="mini" class="name">
							<el-option label="未定义" :value="0"></el-option>
							<el-option label="取消申诉" :value="-2"></el-option>
							<el-option label="已申诉" :value="142"></el-option>
							<el-option label="已转发" :value="144"></el-option>
							<el-option label="已处理" :value="146"></el-option>
							<el-option label="已审核" :value="148"></el-option>
							<el-option label="已认可" :value="160"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="任务编号">
						<el-input v-model="adminappealParameter.taskId" class="name" placeholder="请输入任务编号" size="mini" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"  @blur="salaryChange"></el-input>
					</el-form-item>
					<el-form-item label="报告编号">
						<el-input v-model="adminappealParameter.accNo" class="name" placeholder="请输入报告编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="设备类型">
						<el-select v-model="adminappealParameter.modalityType" placeholder="请选择设备类型" size="mini" class="name">
							<el-option v-for="(item,index) in modalityTypeSelect" :key="index" :label="item.text" :value="item.sorts"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申诉时间">
						<el-date-picker
							class="time mar4"
							v-model="pickerDate.date"
							@change="datePicker"
							type="monthrange"
							size="mini"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							value-format="yyyy/MM"
							format="yyyy-MM"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="search" round>查询</el-button></el-form-item>
				</el-form>
			</div>

			<div class="centerHome">
				<div class="ccHomel">
					<div class="compentTable">
						<el-table class="qcTable" :data="adminappealInfoList.AppealInfos" v-loading="loading">
							<el-table-column prop="AccNo" label="报告编号" min-width="130"></el-table-column>
							<el-table-column prop="ModalityType" label="设备类型"></el-table-column>
							<el-table-column prop="Id" label="任务编号"></el-table-column>
							<el-table-column prop="CheckingItems" label="检查项目"></el-table-column>
							<el-table-column prop="RawScore" label="平均分"></el-table-column>
							<el-table-column prop="ACreateDateTime" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>
							<el-table-column prop="ACreateDt" min-width="100" :formatter="formattertime" label="完成时间"></el-table-column>
							<el-table-column prop="AppealStatusName" label="状态"></el-table-column>
							<el-table-column prop="" label="操作" width="180">
								<template slot-scope="scope">
									<span class="tableOpe marr15" @click="experClick(scope.row)">查看</span>
									<span class="tableOpe textColorRed" v-if="scope.row.AppealStatus==144||scope.row.AppealStatus==146" @click="withdraw(scope.row)">撤回</span>
									<span class="tableOpe textColorRed pelorous" v-if="scope.row.AppealStatus == 142" @click="forward(scope.row)">转发</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next" :total="adminappealInfoList.TotalCount" :page-size='adminappealParameter.PageCount' :current-page='adminappealParameter.PageIndex' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="仲裁专家列表" :visible.sync="dialogexpert" width="80%" :close-on-click-modal="false" class="scrollbar exportFrom dialogFrom">
			<div class="dialogSearch">
				<div>
					<el-form ref="form" label-width="85px" :model="appealExpertListParameter" class="qcFrom disflex">
						<el-form-item label="关键词" prop="keyword">
							<el-input v-model="appealExpertListParameter.Keyword" class="name" size="mini" placeholder="姓名/手机号"></el-input>
						</el-form-item>
						<el-form-item><el-button type="primary" size="small" @click="exportsearch">查询</el-button></el-form-item>
					</el-form>
				</div>
			</div>
			<el-table class="qcTable scrollbar" :data="appealExpertList.Experts" ref="multipleTable" max-height="350">
				<el-table-column prop="Name" label="专家姓名" width="100"></el-table-column>
				<el-table-column prop="LoginId" label="手机号" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.LoginId == ' '">—</span>
						<span v-else>{{ scope.row.LoginId }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertFromType" label="专家来源">
					<template slot-scope="scope">
						<span v-show="scope.row.ExpertFromType == 0">未知</span>
						<span v-show="scope.row.ExpertFromType == 1">专委会</span>
						<span v-show="scope.row.ExpertFromType == 2">集团外</span>
						<span v-show="scope.row.ExpertFromType == 3">集团内</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertLevelType" label="专家分组">
					<template slot-scope="scope">
						<span v-if="scope.row.ExpertLevelType == 0">—</span>
						<span v-else>{{ scope.row.ExpertLevelType }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertMajor" label="专家专业">
					<template slot-scope="scope">
						<span v-show="scope.row.ExpertMajor == 0">未知</span>
						<span v-show="scope.row.ExpertMajor == 1">超声</span>
						<span v-show="scope.row.ExpertMajor == 2">放射</span>
						<span v-show="scope.row.ExpertMajor == 3">核医学</span>
					</template>
				</el-table-column>
				<el-table-column prop="ModalityTypes" label="擅长设备">
					<template slot-scope="scope">
						<span v-if="scope.row.ModalityTypes == null">—</span>
						<span v-else>{{ scope.row.ModalityTypes }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="BodyParts" label="擅长部位">
					<template slot-scope="scope">
						<span v-if="scope.row.BodyParts == null">—</span>
						<span v-else>{{ scope.row.BodyParts }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="Title" label="专家职称">
					<template slot-scope="scope">
						<span v-if="scope.row.Title == null">—</span>
						<span v-else>{{ scope.row.Title }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" fixed="right">
					<template slot-scope="scope">
						<span class="tableOpe" @click="choice(scope.row)">选择</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pages">
				<el-pagination
					class="pageAll"
					align="center"
					layout="prev, pager, next"
					:total="appealExpertList.TotalCount"
					:page-size="appealExpertListParameter.pageCount"
					:current-page="appealExpertListParameter.pageIndex"
					@current-change="exportcurrentChange"
				></el-pagination>
			</div>
		</el-dialog>
		<el-dialog
		  title="确认提示"
		  :visible.sync="dialogchoice"
		  width="30%"
		  center>
		  <span class="colwhite">您确定将这份申诉报告转发给{{expertRow.Name}}仲裁专家仲裁吗?</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogchoiceClick(true)">取 消</el-button>
		    <el-button type="primary" @click="dialogchoiceClick(false)">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			pickerDate: {},
			TaskListArrData: [],
			dialogchoice:false,
			dialogexpert: false,
			expertRow:{},
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['loading','modalityTypeSelect']),
		...Vuex.mapState('managerPlanList',['qcresultsList']),
		...Vuex.mapState('doctor',['adminappealParameter','adminappealInfoList','appealExpertListParameter','appealExpertList','appealDetail',]),
	},
	created() {},
	activated() {
		this.GetadminAppealInfoList();
	},
	
	methods: {
		...Vuex.mapMutations('breadcrumb',['setqcresultsShow']),
		...Vuex.mapMutations('doctor', ['setisSubmintflag','samplingTaskGuid','setIsSubmint','setDetalLoading','setReportGuid', 'setDetailsParameter','setGradeIndex']),
		...Vuex.mapActions('doctor', ['GetadminAppealInfoList','GetReportDetail','CancelAppealInfo','GetAppealExpertList','DistributeAppeal','RollBackAppealById']),
		...Vuex.mapActions('managerPlanList',['GetQCResultsByTask']),
		datePicker(event) {
			this.adminappealParameter.startDt = event[0];
			this.adminappealParameter.endDt = event[1];
		},
		forward(row){
			this.dialogexpert = true;
			this.appealExpertListParameter.Keyword = '';
			this.appealDetail.AppealInfoGuid = row.AppealInfoGuid;
			this.GetAppealExpertList();
		},
		choice(row){
			this.dialogexpert = false;
			this.dialogchoice = true;
			this.expertRow = row;
		},
		dialogchoiceClick(type){
			if (type) {
				this.dialogexpert = true;
				this.dialogchoice = false;
			}else{
				this.dialogchoice = false;
				this.expertRow.AppealInfoGuid = this.appealDetail.AppealInfoGuid;
				this.expertRow.ExpertUserGuid = this.expertRow.UserGuid;
				this.DistributeAppeal(this.expertRow).then(_ => {
					this.GetadminAppealInfoList();
				});
			}
		},
		exportsearch() {
			this.appealExpertListParameter.PageIndex = 1;
			this.GetAppealExpertList();
		},
		exportcurrentChange(val) {
			this.appealExpertListParameter.PageIndex = val;
			this.GetAppealExpertList();
		},
		search() {
			this.adminappealParameter.PageIndex = 1;
			this.GetadminAppealInfoList();
		},
		currentChange(val){
			this.adminappealParameter.PageIndex = val;
			this.GetadminAppealInfoList();
		},
		withdraw(row) {
			let _this = this;
			this.$confirm('确定撤回该报告状态吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.RollBackAppealById({
					AppealId: row.AppealInfoGuid
				}).then(res=>{
					this.GetadminAppealInfoList();
					_this.$message.success('撤回成功');
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消撤回'
				});
			});
		},
		experClick(val){
			this.setDetalLoading(true);
			//详情不可编辑
			this.setIsSubmint(true);
			this.setisSubmintflag(true);
			this.setqcresultsShow(false);
			this.qcresultsList.Name = val.Name;
			this.setReportGuid(val.ReportGuid);
			this.samplingTaskGuid.ExpertUserId = val.ExpertUserGuid;
			this.qcresultsList.expertUserId = val.ExpertUserGuid;
			this.qcresultsList.ReportGuid = val.ReportGuid;
			this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
			this.qcresultsList.AppealInfoGuid = val.AppealInfoGuid;
		
			this.setDetailsParameter({
				reportGuid: this.qcresultsList.ReportGuid,
				samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
				ExpertUserGuid: this.qcresultsList.expertUserId
			})
			this.GetQCResultsByTask({
				samplingtaskguid:this.qcresultsList.SamplingTaskGuid,
				reportGuid:this.qcresultsList.ReportGuid
			})
			// this.GetReportDetail();
			this.$router.push("/home/doctor/scoring");
		},
		formattertime(row, column, cellValue) {
			if (cellValue != '' && cellValue != null) {
				return cellValue.substring(0, cellValue.length - 3);
			} else {
				return cellValue;
			}
		},
		salaryChange(){
			this.adminappealParameter.taskId = e.target.value;
		}
	}
};
</script>
